import React from 'react';
import PropTypes from 'prop-types';

export const Unknown = ({ staticContext }) => {
  staticContext.status = 404;
  return (
    <h1>Route not yet implemented</h1>
  );
};

Unknown.propTypes = {
  staticContext: PropTypes.shape(),
};

Unknown.defaultProps = {
  staticContext: {},
};
